import React from 'react';
import { useSelector } from 'react-redux';
import { numberWithCommas, partyColours } from '../../utils/functions';

export default function List() {
  const partyData = useSelector((state) => state.data.partyData);

  const style = {
    display: partyData.length > 0 ? 'block' : 'none',
  };

  function getList() {
    if (partyData.length > 0) {
      return partyData.map((obj) => {
        const perc = Math.round(obj.perc * 10000) / 100;
        const barStyle = {
          height: '8px',
          width: `${perc}%`,
          backgroundColor: partyColours(obj.pa),
        };

        return (
          <div key={obj.p}>
            <div className="row-wrap info">
              <div className="tParty">{obj.p}</div>
              <div className="tVotes">{numberWithCommas(obj.votes)}</div>
              <div className="tPerc">{perc}%</div>
            </div>
            <div className="row-wrap bar">
              <div className="row" style={barStyle} />
            </div>
          </div>
        );
      });
    }
    return <div />;
  }
  return (
    <section className="content-wrap" style={style}>
      <div className="list-wrap">
        <div className="row-wrap head">
          <div className="tParty head">Party</div>
          <div className="tVotes head">First Preference Votes</div>
          <div className="tPerc head">Percentage</div>
        </div>
        {getList()}
      </div>
    </section>
  );
}
